<template>
  <div
    class="grid grid-rows-[auto_1fr] h-full overflow-hidden font-[Cubic] mission-journey-item text-white relative"
  >
    <ThreadsNav
      show-back
      :show-center="false"
      class="relative z-[2] w-full bg-transparent"
    />
    <div class="flex-1 overflow-hidden">
      <MissionJourneyBook />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.mission-journey-item {
  background: #745ae5;
}
</style>
